
import { defineComponent, ref, computed, nextTick, reactive } from 'vue';
import { useI18n } from "vue-i18n/index";
import type { FormInstance, FormRules } from "element-plus";
import { useStore } from "vuex";
import { errManager, showNotification } from '@/core/config/Tools';
import clubService from "@/core/services/InstitutionService"

export default defineComponent({
    props: {
        setting: {
            type: Object,
            required: true,
            default: () => ({})
        },
        action: {
            type: String,
            required: true,
            default: 'new'
        },
        item: {
            type: Object,
            required: false,
            default: () => ({})
        }
    },
    setup(props, { emit }) {
        const { t } = useI18n();
        const store = useStore();
        const drawerVisible = ref(false);
        const titleDrawer  = ref('');
        
        const loader = ref(false);
        const ruleFormRef = ref<FormInstance>();
        const listCategorie = ref<any>([]);
        const listTypes = ref<any>([]);
        const listStatus = ref<any>([]);

        const openDrawer = () => {
            drawerVisible.value = true;
        };

        const form = reactive<any>({
            phone: []
        })
        const rules = reactive<FormRules>({})

        const listZone: any = computed<any>(() => {
            return store.getters.currentUser.zone;
        });

        const listCountry: any = computed<any>(() => {
            return store.getters.currentUser.country;
        });

        const onOpen = () => {
            form.phone = [];
            titleDrawer.value = props.action == 'new' ? 'Registrar institución' : 'Editar institución'
            listTypes.value = props.setting.types
            listCategorie.value = props.setting.categories
            listStatus.value = props.setting.status

            if (props.action == 'edit')
                onEdit()
        }

        const onClosed = () => {
            titleDrawer.value = ''
            resetForm(ruleFormRef.value)
            Object.keys(form).forEach(key => delete form[key]);
        }

        const addPhone = () => {
            form.phone.push({ type: '', countryCode: form.country?.postalcode, number: '' });
        };

        const removePhone = (index: number) => {
            form.phone.splice(index, 1);
        };

        const resetForm = (formEl: FormInstance | undefined) => {
            if (!formEl) return;
            formEl.resetFields();
        };

        const submitForm = async (formEl: FormInstance | undefined) => {
            if (!formEl) return;
            await formEl.validate((valid) => {
                if (valid)
                    (props.action == 'new') ? save() : update()

            });
        };

        const onEdit = async () => {
            loader.value = true
            await clubService.edit(props.item.idinstitution)
                .then((res) => {
                    const newPhone = Array.isArray(res.data.phone)
                    ? res.data.phone
                    : [{
                        type: '',
                        countryCode: form.country?.postalcode || '',
                        number: typeof res.data.phone === 'string' || typeof res.data.phone === 'number'
                        ? String(res.data.phone)
                        : ''
                    }];

                Object.assign(form, {
                    ...res.data,
                    phone: newPhone
                })
                    
                    loader.value = false
                }).catch(({ response }) => {
                    loader.value = false
                    errManager(response)
                })
        }

        const save = () => {
            loader.value = true
            clubService.save(form)
                .then((res) => {
                    loader.value = false;
                    if(res.data?.status == 'success') drawerVisible.value = false;
                    showNotification(res.data);
                    emit("onResponse", res.data);
                }).catch(({ response }) => {
                    loader.value = false
                    errManager(response)
                })
        }

        const update = () => {
            loader.value = true
            clubService.update(form.idinstitution, form)
                .then((res) => {
                    loader.value = false;
                    if(res.data?.status == 'success') drawerVisible.value = false;
                    showNotification(res.data);
                    emit("onResponse", res.data)
                }).catch(({ response }) => {
                    loader.value = false
                    errManager(response)
                })
        }

        return {
            t,
            loader,
            drawerVisible,
            titleDrawer,
            ruleFormRef,
            form,
            rules,
            listCategorie,
            listTypes,
            listZone,
            listCountry,
            listStatus,
            //event
            onOpen,
            onClosed,
            openDrawer,
            addPhone,
            removePhone,
            onEdit,
            resetForm,
            submitForm,
        }
    },
})
